
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { blogPosts } from '../../data/blogData';
import styles from './BlogListPage.module.css';

const BlogListPage = () => {
  const sortedPosts = [...blogPosts].sort((a, b) => {
    const dateA = new Date(a.date.replace('년 ', '-').replace('월 ', '-').replace('일', ''));
    const dateB = new Date(b.date.replace('년 ', '-').replace('월 ', '-').replace('일', ''));
    return dateB.getTime() - dateA.getTime();
  });

  return (
    <div className={styles.container}>
      <Helmet>
        <title>Enzo's Dev & Invest Log</title>
        <meta name="description" content="개발과 투자에 대한 인사이트와 기록을 공유하는 블로그입니다." />
      </Helmet>
      <h1 className={styles.title}>Enzo's Dev & Invest Log</h1>
      <div className={styles.postsGrid}>
        {sortedPosts.map((post) => (
          <Link to={`/blog/${post.id}`} key={post.id} className={styles.cardLink}>
            <div className={styles.card}>
              <div className={styles.cardContent}>
                <span className={styles.category}>
                  {post.id.includes('etf') || post.id.includes('pension') || post.id.includes('compound') ? '투자' : '개발'}
                </span>
                <h2 className={styles.postTitle}>{post.title}</h2>
                <p className={styles.summary}>{post.summary}</p>
                <p className={styles.date}>{post.date}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogListPage;
